module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "flat": "",
      "xs12": "",
      "full-width": ""
    }
  }, [(_vm.withTitle && _vm.window === 0 && _vm.appointmentIds) ? _c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n      " + _vm._s(_vm.$tc('messages.selectedappointments', _vm.appointmentIds.length, {
    n: _vm.appointmentIds.length
  })) + "\n      "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', {
    key: 0
  }, [(_vm.codes.length > 0) ? [_c('v-list', {
    staticClass: "mb-0"
  }, [_vm._l((_vm.codes), function(code, index) {
    return [_c('v-list-tile', {
      key: code.key
    }, [(code.currency) ? _c('v-list-tile-avatar', [_vm._v("\n                    " + _vm._s(_vm.formatCurrency(code.currency, code.price)) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "pl-2"
    }, [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(code.icd10) + "\n                    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                      " + _vm._s(code.process) + "\n                    ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.del(index)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
      key: ("d-" + index),
      attrs: {
        "inset": ""
      }
    })]
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "loading": _vm.loading,
      "disabled": _vm.appointmentIds.length === 0 || _vm.codes.length === 0
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                  Save codes")])], 1)] : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-form', {
    staticClass: "grey lighten-4",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.fields), function(field) {
    return _c('v-flex', {
      key: field.label,
      attrs: {
        "xs12": "",
        "sm4": ""
      }
    }, [_c('v-text-field', _vm._b({
      staticClass: "mx-1 mt-1 pb-0",
      attrs: {
        "solo": !_vm.$vuetify.breakpoint.xs
      },
      on: {
        "keypress": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.add.apply(null, arguments)
        }
      },
      model: {
        value: (_vm.code[field.key]),
        callback: function($$v) {
          _vm.$set(_vm.code, field.key, $$v)
        },
        expression: "code[field.key]"
      }
    }, 'v-text-field', field, false))], 1)
  }), 1), _vm._v(" "), _c('v-layout', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "disabled": !_vm.valid,
      "small": "",
      "flat": ""
    },
    on: {
      "click": _vm.add
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n                Add code")], 1)], 1)], 1)], 2), _vm._v(" "), _c('v-window-item', {
    key: 1
  }, [_c('v-card', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "green"
    }
  }, [_vm._v("check_circle")]), _vm._v(" "), _c('p', {
    staticClass: "mt-4 blockquote"
  }, [_vm._v("Codes have been added")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.window = 0
      }
    }
  }, [_vm._v("Add more")])], 1), _vm._v(" "), (_vm.withDone) ? _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Done")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    model: {
      value: (_vm.processcodepicker),
      callback: function($$v) {
        _vm.processcodepicker = $$v
      },
      expression: "processcodepicker"
    }
  }, [_c('v-system-bar', {
    staticClass: "visible-ios-only main",
    attrs: {
      "color": _vm.themeColor
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dark": "",
      "dense": "",
      "short": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.processpicker')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.processcodepicker = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('process-code-picker', {
    attrs: {
      "initial-search-string": _vm.processSearchString
    },
    on: {
      "input": _vm.setProcessCode
    },
    model: {
      value: (_vm.code.process),
      callback: function($$v) {
        _vm.$set(_vm.code, "process", $$v)
      },
      expression: "code.process"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.processcodepicker = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    model: {
      value: (_vm.ICD10codepicker),
      callback: function($$v) {
        _vm.ICD10codepicker = $$v
      },
      expression: "ICD10codepicker"
    }
  }, [_c('v-system-bar', {
    staticClass: "visible-ios-only main",
    attrs: {
      "color": _vm.themeColor
    }
  }), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dark": "",
      "dense": "",
      "short": "",
      "color": _vm.themeColor
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('dialogs.titles.icd10picker')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.ICD10codepicker = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('icd-picker', {
    attrs: {
      "touch": _vm.icdtouch,
      "initial-search-string": _vm.codeSearchString
    },
    on: {
      "input": _vm.setIcdCode
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.ICD10codepicker = false
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91ea6234","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/BulkAddCodes.vue
// module id = 1497
// module chunks = 9